import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import InvestmentOptions from './InvestmentOptions';
import '../css/FutureStrategy.css';

class FutureStrategy extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    componentDidMount(){
        this.props.startLoadingMemberFutureStrategy(this.props.match.params.usrMemberSetId);
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        //const slPercent = []
        
        return(
            <div>
                <h2 style={{color: "#52800a", fontSize:"21.3333px"}}>{t('futureStrategy:investmentStrategy')}</h2>
                <div style={{marginTop:"-10px", fontSize: "12px"}}>
                    {t('futureStrategy:currentStrategy')+t('futureStrategy:strategyDesc')}
                </div> 
                {
                    !this.props.futureStrategy ? <div style={{marginLeft: "10px", marginTop: "10px"}}>Fetching Future Strategy....</div> :
                        <table className="table-responsive superlifeLegacyPlan" style={{marginLeft: "10px", marginRight: "1px"}} id="futureStrategyTable">
                           <thead>
                               <tr>
                                    <th></th>
                                    {
                                        this.props.futureStrategy.slAccounts &&
                                            <th colSpan={this.props.futureStrategy.slAccounts.length}>{t('adviserHomePage:superlife')}</th>
                                    }
                                    {
                                        this.props.futureStrategy.ksAccount &&
                                            <th>{this.props.futureStrategy.ksAccount.account}</th>
                                    }
                               </tr>
                               <tr>
                                   <th></th>
                                   {
                                       this.props.futureStrategy.slAccounts &&
                                        this.props.futureStrategy.slAccounts.map(slAccount => 
                                            <th>{slAccount.account}</th>)
                                   }
                                   {
                                       this.props.futureStrategy.ksAccount && <th></th>
                                   }
                               </tr>
                               <tr>
                                   <th>{t('futureStrategy:strategy')}</th>
                                   {
                                       this.props.futureStrategy.slAccounts && 
                                        this.props.futureStrategy.slAccounts.map(slAccount => 
                                            <th>{slAccount.description}</th>)
                                   }
                                   {
                                       this.props.futureStrategy.ksAccount && 
                                        <th>{this.props.futureStrategy.ksAccount.description}</th>
                                   }
                               </tr>
                               <tr>
                                   <th>{t('futureStrategy:fund')}</th>
                                   {
                                       this.props.futureStrategy.slAccounts && 
                                        this.props.futureStrategy.slAccounts.map(slAccount => 
                                            <th>{t('futureStrategy:percentIn')+t('futureStrategy:fund')}</th>)
                                   }
                                   {
                                       this.props.futureStrategy.ksAccount && 
                                        <th>{t('futureStrategy:percentIn')+t('futureStrategy:fund')}</th>
                                   }
                               </tr>
                           </thead>
                           <tbody>
                               {
                                   !this.props.futureStrategy.funds ? <div>Fetching Future Strategy</div> : 
                                   this.props.futureStrategy.funds.map(fund => 
                                    <tr>
                                        <td style={{textAlign: "left", fontWeight: fund.code === "TOT" && "bold"}}>{fund.description}</td>
                                        {
                                            fund.slPercent && fund.slPercent.Member && <td>{fund.slPercent.Member} </td>
                                        }
                                        {
                                            fund.slPercent && fund.slPercent.Employer && <td>{fund.slPercent.Employer}</td>
                                        }
                                        {
                                            fund.slPercent && fund.slPercent.Voluntary && <td>{fund.slPercent.Voluntary}</td>
                                        }
                                        {
                                            fund.ksPercent && <td>{fund.ksPercent}</td>
                                        }
                                    </tr>)

                               }
                           </tbody>
                        </table>
                }
                {
                    this.props.futureStrategy && this.props.futureStrategy.investmentOptions ?
                    <InvestmentOptions {...this.props}/> :<></>
                }
            </div>
        )
    }
}
export default withTranslation()(FutureStrategy);